export { default as propsDecorator } from './props';
export { default as extendDecorator } from './extend';
export { default as viewModelDecorator } from './viewModel';